import React from 'react';
import { HVAConversationProvider } from './HVADynamicAgentConversationContext';
import HVADynamicConversationModalContent from './HVADynamicConversationModalContent';
import { HVADynamicConversationModalProps } from './HVADynamicAgentData';

const HVAHellenicCadasterModal: React.FC<
  HVADynamicConversationModalProps
> = props => {
  return (
    <HVAConversationProvider>
      <HVADynamicConversationModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVAHellenicCadasterModal;
